import { useTranslation } from 'react-i18next';
import styles from './StatusPill.module.css';

/* All status flavours used by the Finance page — invoices,
   orders, payments, budget rows, AI insight chips, and the
   selected-quote tick. One pill component instead of three
   so the visual language stays consistent across tabs. */
export type FinanceStatus =
  | 'approved'
  | 'submitted'
  | 'paid'
  | 'draft'
  | 'discrepancy'
  | 'delivered'
  | 'in-transit'
  | 'ordered'
  | 'pending'
  | 'on-track'
  | 'over-budget'
  | 'under-budget';

const TONE: Record<FinanceStatus, string> = {
  approved:      styles.green ?? '',
  submitted:     styles.amber ?? '',
  paid:          styles.blue ?? '',
  draft:         styles.gray ?? '',
  discrepancy:   styles.red ?? '',
  delivered:     styles.green ?? '',
  'in-transit':  styles.blue ?? '',
  ordered:       styles.amber ?? '',
  pending:       styles.amber ?? '',
  'on-track':    styles.green ?? '',
  'over-budget': styles.red ?? '',
  'under-budget':styles.blue ?? '',
};

interface IStatusPillProps {
  status: FinanceStatus;
}

export function StatusPill({ status }: IStatusPillProps) {
  const { t } = useTranslation();
  return (
    <span className={`${styles.pill} ${TONE[status]}`}>
      {t(`finance.status.${status}`)}
    </span>
  );
}
